import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ElementRef, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Icons } from '@vex/icons/icons';
import { DateFormatPipe } from '@vex/pipes/date-format/date-format.pipe';
import { DeviceService } from '@vex/http-service/device.service';
import { HelperService } from '@vex/services/helper.service';
import { CloudConnectStateService } from '@vex/constants/cloud-connect-state';
import { PopoverService } from '@vex/components/popover/popover/popover.service';
import { PopoverTooltipComponent } from '@vex/components/popover/popover-tooltip/popover-tooltip.component';
import { ResourceSate } from '@vex/model/blueprint-list';
import { MatDialog } from '@angular/material/dialog';
import { ViewDiffCodeComponent } from '@vex/components/view-diff-code/view-diff-code.component';
import { ConfirmCancelDeploymentComponent } from '../confirm-cancel-deployment/confirm-cancel-deployment.component';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'vex-pre-deployment',
  templateUrl: './pre-deployment.component.html',
  styleUrls: ['./pre-deployment.component.scss'],
  providers: [DateFormatPipe],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
})
export class PreDeploymentComponent extends Icons implements OnInit,OnDestroy {
  @Input() postingBlueprint: any[] = [];
  @Input() conflictContext: any = null;
  @Output() onClose = new EventEmitter<boolean>();
  expandedDeviceIndex: number = 0;
  devices: any[] = [];
  ResourceSate = ResourceSate;
  dialogRef;
  private destroy$ = new Subject<void>();
  deviceHeight: string = '';
  expandDeviceHeight: string = '';
  deviceCardFullHeight: string = '';

  constructor(
    public helperService: HelperService,
    public cloudConnectStateService: CloudConnectStateService,
    private popover: PopoverService,
    private dialog: MatDialog,
    private deviceService: DeviceService,
    private router: Router,
  ) {
    super();
  }

  getHeight(height: number = 0) {
    return (window.innerHeight - height).toString() + 'px';
  }

  copyToClipboard(text) {
    navigator.clipboard
      .writeText(text)
      .then(() => {})
      .catch((error) => {});
  }

  toggleExpandDevice(index: number): void {
    this.expandedDeviceIndex = this.expandedDeviceIndex === index ? null : index;
  }

  checkJobConflicts(postingBlueprint: any[] = []) {
    this.helperService.loadingSpinner = true;
    this.postingBlueprint = postingBlueprint;
    this.deviceService.checkJobConflicts(postingBlueprint).pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        this.devices = response;
        this.helperService.loadingSpinner = false;
      },
      (error) => {
        this.helperService.loadingSpinner = false;
      }
    );
  }

  searchDevices(name) {
    for (let device of this.devices) {
        device.isHide = name && !device.Name?.toLowerCase().includes(name.toLowerCase());
    }
  }

  get getDevice() {
    return this.devices.filter(device => !device.isHide);
  }

  showInfo(origin: ElementRef | HTMLElement, text: string) {
    this.popover.open({
      content: PopoverTooltipComponent,
      origin,
      data: { heading: 'Instructions', text: text },
      position: [
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });
  }

  compareDevice(device) {
    let currentInventory = this.postingBlueprint[0];
    const sourceInventoryId = device?.InventoryId;
    this.dialog.open(ViewDiffCodeComponent, {
      width: '98%',
      maxWidth: '98vw',
      height: '95%',
      maxHeight: '95vw',
      disableClose: true,
      data: { title: 'View Diff', SourceInventoryId: sourceInventoryId, TargetInventory: currentInventory }
    });
  }

  ngOnInit() {
      this.deviceHeight = this.getHeight(300);
      this.expandDeviceHeight = this.getHeight(460);
      this.deviceCardFullHeight = this.getHeight(220);
      const validatedDevices = this.conflictContext?.Devices || this.conflictContext?.devices;
      if (Array.isArray(validatedDevices)) {
        this.devices = validatedDevices;
        this.helperService.loadingSpinner = false;
      } else {
        this.checkJobConflicts(this.postingBlueprint);
      }
  }


  openConfirmationModal() {
    this.dialogRef = this.dialog.open(ConfirmCancelDeploymentComponent, {
      maxWidth: '100vw',
      width: '50%',
      disableClose: true
    });

    this.dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((dialogResult) => {
      if (dialogResult === true) {
        this.onNextStepper();
      }else if(dialogResult === false){
        this.router.navigate(['blueprintdesigner/list']);
      }
    });
  }

  onNextStepper(){
    this.onClose.emit(true);
  }

   ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
